module.exports = __webpack_public_path__ + "static/media/eyeRemove.49c27d44.svg";